const cardItems = [
  {
    title: '星之妖精',
    subtitle: '星辰觉醒篇热更中',
    desc: '少女与星辰的契约，妖精王国命运由此改变',
    tag: '奇幻·连载',
    img: 'https://readdy.ai/api/search-image?query=Beautiful%20manga%20cover%20art%20featuring%20a%20magical%20girl%20with%20long%20flowing%20silver%20hair%20surrounded%20by%20starry%20constellations%20and%20sparkling%20dust%20wearing%20an%20elegant%20fantasy%20dress%20against%20a%20deep%20night%20sky%20with%20nebula%20colors%20soft%20glowing%20effects%20detailed%20character%20illustration%20clean%20background&width=400&height=560&seq=card-manga-01&orientation=portrait',
  },
  {
    title: '魔导师传说',
    subtitle: '终章倒计时',
    desc: '传奇魔法师的最后冒险，两百年史诗即将落幕',
    tag: '魔幻·连载',
    img: 'https://readdy.ai/api/search-image?query=Manga%20cover%20illustration%20of%20a%20powerful%20wizard%20in%20ornate%20robes%20holding%20a%20glowing%20staff%20surrounded%20by%20ancient%20runes%20and%20magical%20energy%20circles%20dramatic%20backlight%20from%20a%20full%20moon%20dark%20mysterious%20atmosphere%20with%20purple%20and%20golden%20accents%20detailed%20artwork&width=400&height=560&seq=card-manga-02&orientation=portrait',
  },
  {
    title: '小妖精日常',
    subtitle: '萌系治愈榜首',
    desc: '森林小妖精与人类的温馨日常，治愈你的每一天',
    tag: '萌系·连载',
    img: 'https://readdy.ai/api/search-image?query=Kawaii%20manga%20cover%20with%20a%20tiny%20adorable%20fairy%20character%20sitting%20on%20a%20mushroom%20in%20a%20magical%20forest%20garden%20surrounded%20by%20sparkling%20dew%20drops%20and%20tiny%20flowers%20soft%20pastel%20pink%20and%20green%20colors%20dreamy%20atmosphere%20with%20sunlight%20rays%20wholesome%20vibe&width=400&height=560&seq=card-manga-03&orientation=portrait',
  },
  {
    title: '暗夜猎魔人',
    subtitle: '新角色登场',
    desc: '黑暗世界中的猎魔之旅，神秘新伙伴即将加入',
    tag: '奇幻·连载',
    img: 'https://readdy.ai/api/search-image?query=Dark%20fantasy%20manga%20cover%20with%20a%20mysterious%20hunter%20character%20in%20a%20long%20coat%20holding%20a%20silver%20weapon%20standing%20in%20a%20gothic%20cityscape%20at%20night%20with%20fog%20and%20moonlight%20dramatic%20shadows%20cool%20silver%20and%20dark%20blue%20tones%20atmospheric%20detailed%20illustration&width=400&height=560&seq=card-manga-04&orientation=portrait',
  },
  {
    title: '异世界食堂',
    subtitle: '番外篇两连更',
    desc: '穿越异世界开餐厅，用美食连接两个世界的温暖故事',
    tag: '萌系·完结',
    img: 'https://readdy.ai/api/search-image?query=Coz%20manga%20cover%20art%20of%20a%20warm%20restaurant%20scene%20with%20delicious%20food%20on%20a%20wooden%20table%20and%20friendly%20characters%20enjoying%20a%20meal%20together%20steam%20rising%20from%20hot%20dishes%20warm%20golden%20lighting%20from%20hanging%20lamps%20comfortable%20atmosphere%20with%20rich%20warm%20colors&width=400&height=560&seq=card-manga-05&orientation=portrait',
  },
  {
    title: '精灵之森',
    subtitle: '动画化决定',
    desc: '古老精灵族的传奇史诗，一场跨越千年的守护之战',
    tag: '魔幻·连载',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20manga%20cover%20featuring%20a%20beautiful%20elf%20archer%20with%20pointed%20ears%20and%20long%20braided%20hair%20drawing%20a%20glowing%20bow%20in%20an%20enchanted%20forest%20bioluminescent%20plants%20and%20butterflies%20surrounding%20her%20soft%20green%20and%20golden%20lighting%20ethereal%20fantasy%20atmosphere%20detailed%20illustration&width=400&height=560&seq=card-manga-06&orientation=portrait',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          漫画推荐
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14 max-w-lg mx-auto">
          精选热门漫画作品，总有一部让你爱不释手
        </p>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {cardItems.map((item, i) => (
            <article
              key={i}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative w-full aspect-[3/4] overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 rounded-full bg-background-50/85 text-foreground-700 text-xs">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-3">
                <h3 className="font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-primary-600 mt-0.5">{item.subtitle}</p>
                <p className="text-xs text-foreground-500 mt-1.5 leading-relaxed">{item.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}